import Cookies from "js-cookie";
export const SESSION_COOKIE_NAME = "__Secure-Session";
export const getSession = () => Cookies.get(SESSION_COOKIE_NAME);
export const hasSession = () => getSession() !== void 0;
